import { render, staticRenderFns } from "./boardLeftRequReceive.vue?vue&type=template&id=21aa8bf7&scoped=true&"
import script from "./boardLeftRequReceive.vue?vue&type=script&lang=js&"
export * from "./boardLeftRequReceive.vue?vue&type=script&lang=js&"
import style0 from "./boardLeftRequReceive.vue?vue&type=style&index=0&id=21aa8bf7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21aa8bf7",
  null
  
)

export default component.exports